export const debtCatalogueMockData = [
  {
    id: 1,
    title: "Mobile",
    amount: 34,
    type: 0,
  },
  {
    id: 2,
    title: "Internet and Tv",
    amount: 34,
    type: 1,
  },
  {
    id: 3,
    title: "Car Loan Installment",
    amount: 34,
    type: 2,
  },
  {
    id: 4,
    title: "Grocery Expenses",
    amount: 34,
    type: 3,
  },
  {
    id: 5,
    title: "Rent",
    amount: 800,
    type: 3,
  },
  {
    id: 6,
    title: "Electricity Bill",
    amount: 34,
    type: 4,
  },
];
